import cookies from './util.cookies'
import db from './util.db'
import log from './util.log'

const util = {
  cookies,
  db,
  log
}

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function (titleText) {
  const processTitle = process.env.VUE_APP_TITLE || 'D2Admin'
  window.document.title = `${processTitle}${titleText ? ` | ${titleText}` : ''}`
}

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function (url) {
  var a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('id', 'd2admin-link-temp')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(document.getElementById('d2admin-link-temp'))
}

/**
 * @description 处理后端返回的菜单
 * @param {Array} menuList 菜单列表数据
 */
util.menu = function (menuList) {
  let allMenuHeader = []
  menuList.forEach(item => {
    let auth = item.auth === '1'
    let cache = item.cache === '1'
    let menuItem = {
      path: item.path,
      title: item.title,
      auth,
      cache
    }
    if (item.child) {
      let child = this.menu(item.child)
      menuItem.children = child
    }
    allMenuHeader.push(menuItem)
  })
  return allMenuHeader
}

export default util
